import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, branch, withProps } from 'recompose';
import { List } from 'immutable';

import Timeplan from './Timeplan';
import withWorkTypes from '../../../containers/withWorkTypes';

class TimeplanField extends Component {
  // Note the unusual signature of this change handler.
  // Leaves pass a transform which is executed here.
  // We can therefore only pass a subset of the timeplan units to the leaves but perform
  // transforms on the entire set without the performance penalty
  onChangeTimeplanUnits = (transformFunc, ...args) =>
    this.props.input.onChange(
      transformFunc(
        this.props.input.value,
        ...args,
      ),
    );

  render() {
    const {
      input: { value },
      ...passProps
    } = this.props;

    if (!value) {
      return null;
    }
    return (
      <Timeplan
        onChangeTimeplanUnits={this.onChangeTimeplanUnits}
        timeplanUnits={value.filter(o => !o.has('kilometers'))} // Filter out mileageAllowances
        mileageAllowances={value.filter(o => o.has('kilometers'))}
        {...passProps}
      />
    );
  }
}

TimeplanField.defaultProps = {
  disabled: false,
  isEditable: true,
  showWeekHeader: true,
  absentReasons: new List(),
};

TimeplanField.propTypes = {
  isEditable: PropTypes.bool,
  absentReasons: PropTypes.instanceOf(List),
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(List),
    ]).isRequired,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }).isRequired,
  disabled: PropTypes.bool,
  showWeekHeader: PropTypes.bool,
};

export default compose(
  branch(({ workTypes }) => !List.isList(workTypes),
    branch(({ workTypesIds }) => !!workTypesIds,
      withWorkTypes,
      withProps({
        workTypes: new List(),
      }),
    ),
  ),
)(TimeplanField);
